module.exports = {
    helpCenterAPIURL: 'https://todoist.zendesk.com/api/v2',
    helpCenterCacheFilename: './services/help-center/cache-content.json',
    helpCenterAllowedCategories: [
        115000632125 /** Getting Started */, 360002791659 /** Using Todoist */,
        360002791719 /** Billing & Subscriptions */, 115000626249 /** Faq & Troubleshooting */,
        360002791779 /** Integrations */, 13521712913948 /** Teams */,
    ],
    defaultSuccessfulProUpgradeRedirect: '/app/today?upgraded=pro',
    defaultSuccessfulTeamsUpgradeRedirect: '/app/today?upgraded=teams',
    googlePlayAndAppStoreReviewCount: 374000,
}
